<script setup lang="ts">
import { UsersRound, ChevronUp, User2, ShieldUser, Mailbox, Code, KeyRound, Box, Cone, CigaretteOff, ThumbsUp, Flame } from "lucide-vue-next"
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"

import { getAuth } from "@firebase/auth";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"

const localePath = useLocalePath()
const auth = getAuth();

// Menu items.
const items = [

  {
    title: "Feed",
    url: "/admin/feed",
    icon: Mailbox,
  },
  {
    title: "Users",
    url: "/admin/users",
    icon: UsersRound,
  },
  {
    title: "User Auth",
    url: "/admin/add-auth",
    icon: KeyRound,
  },
  {
    title: "Users & Roles",
    url: "/admin/user-roles",
    icon: ShieldUser,
  },
  {
    title: "Quit Success",
    url: "/admin/quit-success",
    icon: CigaretteOff,
  },
  {
    title: "Superkräfte",
    url: "/admin/superpowers",
    icon: Flame,
  },
  
];

const others = [
  {
    title: "Redeem Code Campaigns",
    url: "/admin/campaigns",
    icon: Box,
  },
];
</script>

<template>
  <Sidebar variant="sidebar" collapsible="icon">

    <!-- HEADER -->
    <SidebarHeader>
      <NuxtLink
        to="/"
        class="flex items-center space-x-2 md:space-x-3 rtl:space-x-reverse"
      >
        <SmoxyLogo class="h-12 w-12" />
      </NuxtLink>
      <SidebarMenu>
        
      </SidebarMenu>
    </SidebarHeader>


    <!-- Contentv -->
    <SidebarContent>
      <!-- Admin -->
      <SidebarGroup>
        <SidebarGroupLabel>Admin Menu</SidebarGroupLabel>
        <SidebarGroupContent>
          <SidebarMenu>
              <SidebarMenuItem v-for="item in items" :key="item.title">
                <SidebarMenuButton asChild>
                    <NuxtLink :to="item.url">
                      <component :is="item.icon" />
                      <span>{{item.title}}</span>
                    </NuxtLink>
                </SidebarMenuButton>
              </SidebarMenuItem>
          </SidebarMenu>
        </SidebarGroupContent>
      </SidebarGroup>
      

    </SidebarContent>

    <!-- FOOTER -->
    <SidebarFooter>
        <SidebarMenu>
          <SidebarMenuItem>
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <SidebarMenuButton>
                  <User2 /> {{ auth.currentUser?.displayName || 'User' }}
                  <ChevronUp class="ml-auto" />
                </SidebarMenuButton>
              </DropdownMenuTrigger>
              <DropdownMenuContent
                side="top"
                class="w-[--reka-popper-anchor-width]"
              >
                <DropdownMenuItem><span>Account</span></DropdownMenuItem>
                <DropdownMenuItem @click="auth.signOut()">
                  Sign out
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarFooter>
  </Sidebar>
</template>
